import type { History } from 'history';
import { createBrowserHistory } from 'history';

import getUserConfirmation from 'UnsavedChangesListener/unsavedChangesConfirmation';

export type ReadonlyBrowserHistory = Readonly<History>;
const browserHistory: ReadonlyBrowserHistory = createBrowserHistory({
  getUserConfirmation,
});

/**
 * Custom history object to initialize the React Router with.
 */
export default browserHistory;
